import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation, useQueryClient } from 'react-query'
import deleteProspectEducationService from 'services/delete-prospect-education-service'

export type UseDeleteProspectEducationProps = {} & MutateApiHookType<void>

function useDeleteProspectEducation({
  onMutate,
  onSuccess,
  onError,
}: UseDeleteProspectEducationProps) {
  const queryClient = useQueryClient()

  const { mutate: fetch, isLoading: pending } = useMutation(
    deleteProspectEducationService,
    {
      onSuccess: async (...args) => {
        await queryClient.invalidateQueries(
          '/prospects/{prospectId}/educations'
        )
        onSuccess?.(...args)
      },
      onError,
      onMutate,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useDeleteProspectEducation
